import {createEntityAdapter, createSlice, EntityId} from '@reduxjs/toolkit';
import {mapValues} from 'lodash';
import {StudentEntity} from '~/redux/students/types';
import {RootState} from '~/redux/root-reducer';
import {ReducerState} from '~/utils/thunk-api/type';
import {addStudentRegister} from '~/redux/students/thunk';
import {
  addIdsToSources,
  createSelectAllBySource,
  deleteSuccess,
  fetchSuccess,
  upsertMany,
  upsertOneMutably,
} from '~/utils/thunk-api';
import {DEFAULT_SOURCE_REDUCER_STATE} from '~/utils/thunk-api/constants';
import {SOURCES_STUDENT} from '~/redux/students/entity-config';
import {getObjNthItem} from '~/utils/helpers';

interface InitialState extends ReducerState {}

const sources = mapValues(SOURCES_STUDENT, () => DEFAULT_SOURCE_REDUCER_STATE);

const studentsAdapter = createEntityAdapter<StudentEntity>();

const initialState = studentsAdapter.getInitialState<InitialState>({sources});

const students = createSlice({
  name: 'students',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // builder.addCase(fetchStudents.fulfilled, (state, {payload}) => {
    //   upsertMany(studentsAdapter, state, payload.normalized.entities.students);
    //   fetchSuccess(state, payload);
    // });
    // builder.addCase(addStudentRegister.fulfilled, (state, {payload}) => {
    //   upsertMany(studentsAdapter, state, payload.normalized.entities.students);
    //   addIdsToSources(state, payload.normalized.result, [SOURCES_STUDENT.STUDENTS_PAGE]);
    // });
    // builder.addCase(updateStudent.fulfilled, (state, {payload}) => {
    //   upsertOneMutably(studentsAdapter, state, payload.normalized.entities.students);
    // });
    // builder.addCase(deleteStudent.fulfilled, (state, {payload, meta}) => {
    //   const {arg} = meta;
    //   studentsAdapter.removeOne(state, arg?.id as EntityId);
    //   deleteSuccess(state, arg?.id);
    // });
  },
});

// export const {} = students.actions;

export default students.reducer;

export const {
  selectById: selectStudentById,
  selectIds: selectStudentsIds,
  selectEntities: selectStudentsEntities,
  selectAll: selectAllStudents,
  selectTotal: selectTotalStudents,
} = studentsAdapter.getSelectors((state: RootState) => state.students);

export const [getStudents] = createSelectAllBySource('students', selectStudentsEntities, [
  SOURCES_STUDENT.STUDENTS_PAGE,
]);
